import React from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import { checkServerLive } from 'constants/config';
import { ShowIf } from 'components/utils';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DetailTaiLieuRowItem extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'tinhTrangTaiLieuList',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  render() {
    let TinhTrangTaiLieu = this.state.data.filter(state => {
      return state.giaTri == this.props.item.tinhTrangTaiLieu
    });
    return (
      <tr>
        <td>{(this.props.count) ? this.props.count : ''}</td>
        <td>{(this.props.item.ten) ? this.props.item.ten : ''}</td>
        {/*<td>{(this.props.item.soTrang) ? this.props.item.soTrang : ''}</td>
        <td>{(this.props.item.loaiTaiLieuTLBC) ? this.props.item.loaiTaiLieuTLBC.ten : ''}</td>*/}
        <td>{TinhTrangTaiLieu.length > 0 ? TinhTrangTaiLieu[0].ten : ''}</td>
        <td>
          <ShowIf condition={!checkServerLive}>
            <Link className="txt-underline txt-blue" onClick={fileDownload.bind(this, this.props.item.duongDan, this.props.item.tenFile)} >{(this.props.item.tenFile) ? this.props.item.tenFile : ''} </Link>
          </ShowIf>
          <ShowIf condition={checkServerLive}>
            <Link className="txt-underline txt-blue" onClick={()=>{downloadFile(this.props.item.duongDan, this.props.item.tenFile)}} >{(this.props.item.tenFile) ? this.props.item.tenFile : ''} </Link>
          </ShowIf>
        </td>
      </tr>
    );
  }
}

DetailTaiLieuRowItem.defaultProps = {
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.tinhTrangTaiLieuList
  }
}

export default connect(bindStateToProps)(DetailTaiLieuRowItem);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/datatable/rowItem/DetailTaiLieuRowItem.jsx